import './App.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import MainComponent from './layouts/MainLayout';
import { createTheme, ThemeProvider } from '@material-ui/core';

const theme = createTheme({
  palette: {
    primary: {
      main: '#03E67C',
    },
    secondary: {
      main: '#0B353F',
    },
  },
});

// Zoomcharts license and license key
window.ZoomChartsLicense =
  'ZCP-d4ihh501e: ZoomCharts SDK Internal Use license for Mankara Software Services Pvt Ltd. Valid for 1 chart developers and 3 chart viewers';
window.ZoomChartsLicenseKey =
  'b27fc44f59f0d1a2e446b4d9fc516769508720e79af9cb90c3' +
  '289be2ba7f081217a7fc836488019d7d004b63af35d56947ae90c7be015f6104424b332aa0ed2' +
  '60834283055300f3187800d295971b638a5e2a00deaf7cd3ce2edb610aac410008d5befd0d4aa' +
  '653aa87d39724821fc92a78da178365fd8cab8d39970d19f55d376406c927f36b98c22c669936' +
  'a08045f7b1c7d43bf6e30ed05b150687d24031fed45920832a5f208eb3211ccf19ebf47cc508a' +
  'c021ed1c40a08ab9cb6c73ad47a054fcf6237b1c4ba1ea8081aca728ccd2878422bccbf089964' +
  'e5934932da2fdae6654712f13d37d3162fcc0f0434eb8d3347b617291eeaa1ef26e7b2a026e96';

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <MainComponent />
      </ThemeProvider>
    </Router>
  );
}

export default App;
